const dataLayerCardClickInit = () => {
	const panels = document.querySelectorAll( '.panel' );

	panels.forEach( panel => {
		panel.addEventListener( 'click', e => {
			const panelName = panel.dataset.panelName;

			// Article cards in the panel
			if ( e.target.classList.contains( 'content-item' ) ) {
				const cardDataLayerObject = {
					event: 'widget_click',
					event_action: 'click',
					event_object_type: 'Card',
				};

				if ( panelName === 'popular-articles' ) {
					cardDataLayerObject.event = 'link_click';
					cardDataLayerObject.event_object_type = 'article link';
				}

				const cardTitle = e.target.querySelector( '.content-item__title' );
				const cardEyebrow = e.target.querySelector( '.content-item__subject' );
				const cardInfoLeft = e.target.querySelector( '.content-item__date' );
				const cardInfoRight = e.target.querySelector( '.content-item__tag' );
				const cardLink = e.target.getAttribute( 'href' );
				const cardImage = e.target.querySelector( '.content-item__image' );
				const cardType = e.target.dataset.cardSize ? e.target.dataset.cardSize : 'default';

				// Select all card children. This is used to see where the index is of the current card.
				const children = panel.querySelectorAll( '.content-item' );

				cardDataLayerObject.event_object_text = cardTitle ? cardTitle.textContent.trim() : 'No title';
				cardDataLayerObject.event_category = cardEyebrow ? cardEyebrow.textContent.trim() : 'No category';
				cardDataLayerObject.event_details = cardInfoLeft ? cardInfoLeft.textContent.trim() : 'No info left';
				cardDataLayerObject.event_label = cardInfoRight ? cardInfoRight.textContent.trim() : 'No info right';
				cardDataLayerObject.target_url = cardLink ? cardLink : 'No target URL';
				cardDataLayerObject.event_subtype = cardImage ? 'Contains image on desktop: true' : 'Contains image on desktop: false';
				cardDataLayerObject.event_object_name = `Article - ${cardType} card`;
				cardDataLayerObject.event_object_position = [ ...children ].indexOf( e.target ) + 1;
				cardDataLayerObject.event_object_section_name = panelName ? panelName : 'No section name';

				dataLayer.push( cardDataLayerObject );
			}

			// This is the supplementary click on a panel e.g. Explore more of our Podcasts.
			if ( e.target.closest( 'a.content-item-cta' ) ) {
				const cardTitle = e.target.querySelector( 'p.content-item-cta__text span' );
				const cardLink = e.target.getAttribute( 'href' );
				let positionCount = 1;

				let previousElementSibling = e.target.previousElementSibling;

				// Calculate previous elements so we know the position of this element in the panel
				do {
					positionCount ++;
					previousElementSibling = previousElementSibling.previousElementSibling;
				} while ( previousElementSibling );

				const cardDataLayerObject = {
					event: 'widget_click',
					event_action: 'click',
					event_object_type: 'CTA',
				};

				cardDataLayerObject.event_object_text = cardTitle ? cardTitle.textContent.trim() : 'No title';
				cardDataLayerObject.target_url = cardLink ? cardLink : 'No target URL';
				cardDataLayerObject.event_object_section_name = panelName ? panelName : 'No section name';
				cardDataLayerObject.event_object_position = positionCount;

				dataLayer.push( cardDataLayerObject );
			}
		} );
	} );
};

if ( document.readyState !== 'loading' ) {
	dataLayerCardClickInit();
} else {
	document.addEventListener( 'DOMContentLoaded', dataLayerCardClickInit );
}
